import styled from 'styled-components';
import { Tag } from 'antd';

export const FilterTag = styled(Tag)`
 margin-top: 1px
`;
